import { Provider, ErrorHandler } from '@angular/core';
import { RailProsErrorHandlerService } from '../rail-pros-error-handler.service';

export const errorHandlerProvider: Provider = {
	provide: ErrorHandler,
	useClass: RailProsErrorHandlerService,
};
